<form [formGroup]="formGroup" autocomplete="off" (click)="openMatselect()">
  <div class="content-container">
    <ng-content></ng-content>
  </div>
  <mat-select
    #matSelect
    panelClass="search-autocomplete-select"
    formControlName="selected"
    [compareWith]="compareWithSelectedOption"
    disableOptionCentering
    (openedChange)="focusSearch()"
    [ngStyle]="{ top: selectPosition.top, left: selectPosition.left }"
  >
    <mat-option class="hidden-option"></mat-option>
    <div class="search-container">
      <ds-lib-search-bar
        class="byd-search-bar"
        #searchBar
        [ngStyle]="{ width: width + 'px' }"
        [searchControl]="formGroup.get('search')"
        [placeholder]="placeholder"
      ></ds-lib-search-bar>
      <cdk-virtual-scroll-viewport
        [itemSize]="itemSize"
        [minBufferPx]="height"
        [maxBufferPx]="height"
        class="mat-options-container"
        [ngStyle]="{ height: height + 'px' }"
      >
        <mat-option
          *cdkVirtualFor="let option of filteredOptions | async"
          [value]="option"
          [ngStyle]="{ 'max-width': width + 'px' }"
        >
          {{ option.name }}
        </mat-option>
      </cdk-virtual-scroll-viewport>
    </div>
  </mat-select>
</form>
